import { deviceEventStatusList } from './device-online-status-constants.js'

export const getDeviceOnlineStatus = (state, deviceId) =>
  state.entries.deviceOnlineStatus[deviceId] || deviceEventStatusList.UNKNOWN

export const getDevicesOnlineStatuses = state => state.entries.deviceOnlineStatus
